import { render, staticRenderFns } from "./FiltroCidade.vue?vue&type=template&id=b5a12a80&"
import script from "./FiltroCidade.vue?vue&type=script&lang=js&"
export * from "./FiltroCidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports